import { useMutation } from 'react-query';
import { iteroProposalService } from 'services';

export const useSendProposalViewedNotification = (proposalId: string) => {
  return useMutation(() => {
    return iteroProposalService.sendProposalViewedNotification(proposalId);
  });
};
